<template>
  <label
    class="inc-toggle__input d-inline-flex"
    :for="inputId"
  >
    <input
      :id="inputId"
      v-model="value"
      type="checkbox"
      class="d-none"
      :checked="value"
    >
    <span
      data-grid
      class="p-relative cursor-pointer"
    />
  </label>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ToggleInput',

  props: {
    inputId: {
      type: String,
      default: () => ''
    },

    attributeName: {
      type: String,
      default: () => ''
    },

    modelValue: {
      type: Boolean,
      default: () => false
    }
  },

  emits: ['check', 'update:modelValue'],

  computed: {
    value: {
      get () {
        return !!this.modelValue
      },

      set (value) {
        this.$emit('check', value)
        this.$emit('update:modelValue', value)
      }
    }
  }
})
</script>

<style lang="scss" scoped>
  .inc-toggle__input {
    input[type=checkbox] {
      width: 0;
      height: 0;

      &:checked + span {
        background-color: var(--primary);

        &:after {
          margin: 0 0 0 calc(var(--width) - 8px - var(--width-ball));
        }
      }

      &:active + span:after {
        --width-ball: 70%;
      }
    }

    span {
      --width: 48px;
      --height: 24px;

      padding: 4px;

      width: var(--width);
      height: var(--height);
      border-radius: 24px;
      transition: all .4s ease-in-out;
      background-color: rgb(var(--gray1));

      &:after {
        --width-ball: 16px;
        --height-ball: 16px;

        content: "";

        width: var(--width-ball);
        height: var(--height-ball);

        border-radius: 16px;
        transition: all .3s ease-in-out;
        background-color: rgb(var(--white));
      }
    }
  }
</style>
